import ApiRequestManagerInstance from '../ApiRequestManager';
import { store } from '../../store/store';

function addonFreeRequest(planId?: string) {
  const {
    user: { userId },
  } = store.getState();
  return ApiRequestManagerInstance.post({
    endpoint: {
      url: 'apiUrl',
      version: 'v1',
      section: 'users',
      subsection: `${userId}/plans/${planId}`,
    },
  });
}

export default addonFreeRequest;
